// import ReactDOM from 'react-dom/client';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from '@alifd/next';
import { buildComponents, AssetLoader } from '@alilc/lowcode-utils';
import ReactRenderer from '@alilc/lowcode-react-renderer';
// import { injectComponents } from '@alilc/lowcode-plugin-inject';
import { wsharep, default as wxwebjsk } from '../../utils/share';
import './post.css';

function formatTime(value) {
    if(value) {
        let date = new Date(value * 1000); // 时间戳为秒：10位数
        let year = date.getFullYear();
        let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        let hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        let minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
        let second = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
        return `${year}年${month}月${day}日 ${hour}:${minute}`
    } else {
        return ''
    }
}

export const PageView = () => {
    const params = useParams();
    const [schema_id] = useState(params.id);
    const [type] = useState(params.type);
    const [data, setData] = useState({});

    async function init() {
        // 渲染前置处理，初始化项目 schema 和资产包为渲染模块所需的 schema prop 和 components prop
        // const packages = JSON.parse(window.localStorage.getItem('packages') || '');
        // const projectSchema = JSON.parse(window.localStorage.getItem('projectSchema') || '');
        const assets = await (
            await fetch(
                process.env.REACT_APP_LC_JSON + `/lowcode-assets.json`, { mode: 'cors' }
            )
        ).json();
        let data = {
            id: schema_id
        };
        if(type) {
            data = {
                foreign_id: schema_id,
                type: type
            };
        }
        const packages = assets.packages;
        const res = await (
            await fetch(
                process.env.REACT_APP_LC_FED + `/lowcode/page/get`,
                {
                    method: "POST",
                    mode: 'cors',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                }
            )
        ).json();

        // 获取会议详情
        let meetingId = res.data.foreign_id;
        const meetingRes = await (
            await fetch(
                process.env.REACT_APP_LC_APPAPI + `/api/meeting/getMeetingDetail`,
                {
                    method: "POST",
                    mode: 'cors',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        "head":{},
                        "meetingId": meetingId
                    })
                }
            )
        ).json();
        let meetingInfo = meetingRes.meetingInfoVo;
        let startTime = meetingInfo.startTime;
        let endTime = meetingInfo.endTime;
        // 设置分享
        const title = meetingInfo.meetingName || "肿瘤资讯";
        const desc = formatTime(startTime) + " - " + formatTime(endTime);
        // const desc = meetingInfo.meetingDesc || "与全世界的肿瘤医生一起工作、学习、交流";
        const pic = meetingInfo.picUrl || "https://bosdev.liangyihui.net/temp/1656929599.png";
        // const { title='肿瘤资讯', desc='与全世界的肿瘤医生一起工作、学习、交流', pic='https://bosdev.liangyihui.net/temp/1656929599.png' } = res.data;
        wsharep.sharetitle = title;
        wsharep.sharedesc = desc;
        wsharep.shareurl = window.location.href;
        wsharep.sharepic = pic;
        wxwebjsk();
        document.title = title;

        // 埋点
        const tmp_url = new URL(window.location.href);
        const page_source = tmp_url.searchParams.get('page_source') || '';
        window.sensors && window.sensors.track("ContentDetail", {
            "page_source": page_source,
            "channel_name": "",
            "data_type": "会议",
            "content_name": res.data.title,
            "content_id": meetingId
        });

        const schemaStr = res.data.schema;
        const projectSchema = JSON.parse(schemaStr);

        const { componentsMap: componentsMapArray, componentsTree } = projectSchema;

        // console.log('packages =>', packages);
        // console.log('projectSchema =>', projectSchema);

        const componentsMap = {};
        componentsMapArray && componentsMapArray.forEach((component) => {
            componentsMap[component.componentName] = component;
        });
        const schema = componentsTree && componentsTree[0] || {};

        const libraryMap = {};
        const libraryAsset = [];
        packages.forEach(({ package: _package, library, urls, renderUrls }) => {
            libraryMap[_package] = library;
            if (renderUrls) {
                libraryAsset.push(renderUrls);
            } else if (urls) {
                libraryAsset.push(urls);
            }
        });

        const assetLoader = new AssetLoader();
        await assetLoader.load(libraryAsset);
        const components = buildComponents(libraryMap, componentsMap);

        setData({
            schema,
            components,
        });

        setTimeout(()=>{ // 修复轮播图在iPhone机型尤其是iOS14上高度无法撑开的问题
            let eles = document.getElementsByClassName('next-slick-slide');
            for(let i = 0; i < eles.length; i++){
                eles[i].style.minHeight = 'inherit';
            }
        }, 300);
    }

    const { schema, components } = data;

    if (!schema || !components) {
        init();
        return <Loading fullScreen />;
    }

    return (
        <div className="lowcode-plugin-sample-preview">
            {
                Object.keys(schema).length > 0 ? 
                (<ReactRenderer
                    className="lowcode-plugin-sample-preview-content"
                    schema={schema}
                    components={components}
                />)
                :
                (<div className="empty">
                    <img className="image" src='//bosdev.liangyihui.net/temp/1656914761.png' />
                    <span className="desc">暂无相关内容 ~ </span>
                </div>)
            }
        </div>
    );
};

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render((
//   <PageView />
// ));